import { LIST_ORGANIZATION, GET_ORGANIZATION } from "../actions/types";

const initialState = {
  organization: null,
  organizations: {
    count: 0,
    rows: [],
  },
};

const organizations = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZATION:
      return {
        ...state,
        organization: action.payload,
        organizations: initialState.organizations,
      };
    case LIST_ORGANIZATION:
      return {
        ...state,
        organizations: action.payload,
        organization: initialState.organization,
      };
    default:
      return state;
  }
};

export default organizations;
